import { Activity } from "generated/graphql";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { Header, HistoryItemStyle } from "../style";
import { getActivityDescription, HistoryItemProps } from "../types";


export const HistoryItem : React.FC<HistoryItemProps> = ({activity, identifier, text})=>(
    <>
    <Header identifier={identifier}>
        <p>{_.toLower(activity?.activity_trigger_action).replaceAll("_", " ")}</p>
        <p>{activity?.activity_updated_by ? `${activity?.activity_updated_by?.first_name} ${activity?.activity_updated_by?.last_name}` : "N/A"}</p>
    </Header>
    <div style={HistoryItemStyle}>
        <div style={{ display:"flex", justifyContent:"space-between"}}>
            <p>{text.all.date}: <span>{moment(activity?.activity_date).format("DD/MM/YYYY")}</span></p>
            <p>{text.all.time}: <span>{`${moment(activity?.activity_date).format("HH")}h: ${moment(activity?.activity_date).format("mm")}`}</span></p>
        </div>
        <p style={{fontSize:13, textAlign:"center", fontWeight: "initial"}}>{getActivityDescription(activity?.activity_trigger_action, activity?.activity_trigger_action_data_reason, text)}</p>
    </div>
   </>
)